import { gql } from "@apollo/client";

export const LIST_UNIT_MEASURES = gql`
  query listUnitMeasures(
    $limit: Int
    $offset: Int
    $orderBy: [String!]
    $filter: UnitMeasureFilter!
  ) {
    listUnitMeasures(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        slug
      }
      totalCount
    }
  }
`;
